export default {
  // 导航菜单
  nav: {
    home: '首頁',
    finance: '理財',
    exchange: 'RWA數字資產',
    wallet: '個人資產',
    notice: '公告',
    invite: '邀請鏈接',
    withdrawal: '提現'
  },

  // 首页
  home: {
    title: 'SeekAIpha：開啟 AI 驅動的財富新紀元',
    subtitle: '下一代 DeFi 協議，融合人工智能與通縮經濟，為您打造可持續的加密資產收益引擎',
    explore: '立即探索',
    watchVideo: '觀看視頻解說',
    
    // 核心问题
    coreIssue: '我們解決的核心問題',
    coreIssueDesc: '傳統DeFi已陷入「高收益=高風險」的死亡螺旋。缺乏真實價值創造，是不可持續的旁氏遊戲。',
    
    // 解决方案
    solution: 'SeekAIpha的解決方案',
    solutionDesc: '引入外部盈利與內在通縮，構建價值飛輪。',
    
    // 解决方案列表
    solutionList: {
      ai: {
        title: 'AI驅動的價值創造',
        tips: '(讓機器為你工作)',
        content: '部分資金由頂級AI交易策略管理，所獲利潤自動回購並銷毀SKP代幣，將外部市場的盈利持續注入生態。'
      },
      deflation: {
        title: '極致通縮的稀缺資產',
        tips: '(越流通，越稀缺)',
        content: '通過AI盈利回購、市值維護手續費、初始通縮三大機制，持續減少SKP流通量，為資產價值構築堅固護城河。'
      },
      stability: {
        title: '智能化的市場穩定',
        tips: '(前所未有的防跌設計)',
        content: '獨創「市值維護錢包」，市場賣出即觸發105%自動跟買，為代幣價格提供強大支撐，實現軟性底價錨定。'
      }
    },
    
    // 双核引擎
    dualEngine: '雙核引擎，點燃收益倍增效應',
    
    // 代币介绍
    tokens: {
      skp: {
        title: 'SKP (主權益代幣)',
        supply: '總量：210萬枚 (永久通縮)',
        desc: '您的生態通行證： 用於參與流動性挖礦、獲取靜態收益、社區治理與推廣獎勵。是整個seekAIpha宇宙的硬通貨。'
      },
      skb: {
        title: 'SKB (榮譽獎勵代幣)',
        supply: '總量：21萬枚 (永久通縮)',
        desc: '精英的榮譽勳章： 僅獎勵給V3及以上的社區領袖。總量更稀缺，價值更高，是身份與貢獻的象徵。'
      }
    },
    
    // 生态系统
    ecosystem: '生態系統實時脈搏',
    ecosystemData: {
      burn: '$SKP 總銷毀量',
      profit: 'AI理財總盈利',
      members: '社區總成員數',
      locked: '礦池總鎖倉量',
      fund: '市值維護基金餘額'
    },
    
    // 收益结构
    incomeStructure: '多維收益結構，滿足從入門到領袖的每一階段',
    stages: {
      static: {
        title: '靜態收益 | 穩定基石',
        items: [
          'V0-V3: 1.5% 日化',
          'V4-V6: 2.1% 日化',
          'V7-V8: 3.0% 日化',
          '收益源自生態增長與AI盈利，非純粹通脹'
        ]
      },
      referral: {
        title: '推廣獎勵 | 網絡力量',
        items: [
          '直推 10% | 間推 5%',
          '快速啟動您的網絡效應'
        ]
      },
      leadership: {
        title: '社區領導獎 | 全球業績',
        items: [
          '享受小區業績分紅，比例最高可達 80%',
          '獎勵真正的生態建設者'
        ]
      },
      honor: {
        title: 'SKB榮譽獎勵 | 巔峰榮耀',
        items: [
          'V3及以上會員專享，解鎖第二重財富通道。'
        ]
      }
    },
    
    // FAQ
    faq: {
      title: '您的疑問，我們清晰解答',
      q1: {
        question: 'Q: 我的錢具體去了哪裡？',
        answer: 'A: 每一筆資金都按智能合約嚴格分配：20%由AI理財創收，30%注入DEX底池保駕護航，50%進入市值維護錢包用於穩定幣價。'
      },
      q2: {
        question: 'Q: 如果市場大跌，我的資產安全嗎？',
        answer: 'A: 沒有任何投資是零風險。但我們的「市值維護錢包」和「105%跟買機制」專為對抗下跌而設計，能在市場波動時提供強大的緩衝和支撐，這是傳統DeFi項目不具備的。'
      },
      q3: {
        question: 'Q: 如何開始？',
        answer: 'A: 點擊下方「立即參與」按鈕，連接您的錢包，即可從100 USDT起開始您的seekAIpha之旅。'
      }
    },
    
    // Footer
    footer: {
      cta: '準備好，成為下一代DeFi的早期共建者',
      ctaDesc: '與數萬名先行者一起，駕馭AI的未來',
      downloadWhitepaper: '下載圖文白皮書',
      joinTelegram: '加入官方Telegram'
    }
  },

  // 钱包
  wallet: {
    title: '我的錢包',
    totalAssets: '預估總資產',
    exchange: '兌換',
    withdrawal: '提現',
    myLevel: '我的等級',
    personalPerformance: '個人業績',
    teamPerformance: '傘下業績',
    districtPerformance: '小區業績',
    areaPerformance: '大區業績',
    maxIncome: '最大收益',
    teamNum: '團隊人數',
    remainingIncome: '剩餘收益',
    directNum: '直推人數',
    myAssets: '我的資產',
    assetRecord: '資產記錄',
    accumulatedIncome: '累計收益',
    amount: '數量：',
    source: '來源：',
    time: '時間：',
    noRecord: '暫無記錄'
  },

  // 邀请
  invite: {
    title: 'SeekAIpha：開啟 AI 驅動的財富新紀元',
    subtitle: '下一代 DeFi 協議，融合人工智能與通縮經濟，為您打造可持續的加密資產收益引擎',
    myInviteCode: '我的邀請碼',
    inviteRecord: '邀請記錄',
    registerTime: '註冊時間：',
    performance: '業績',
    noRecord: '暫無記錄',
    myLevel: '我的等級'
  },

  // 公告
  notice: {
    title: '平台公告',
    noMore: '沒有更多了',
    back: '返回',
    viewCount: '次瀏覽'
  },

  // 兑换
  exchange: {
    title: 'Swap兌換',
    balance: '餘額：',
    max: 'MAX',
    swapNow: '立即兌換',
    enterAmount: '請輸入正確兌換金額',
    selectCoin: '請選擇幣種',
    swapFailed: '兌換失敗',
    record: '兌換記錄',
    amount: '數量：',
    time: '時間：',
    noMore: '沒有更多了',
    popup: {
      title: '兌換',
      subtitle: '入金挖SKP',
      depositAmount: '入金數量',
      pay: '立即支付'
    }
  },

  // 理财/入金
  recharge: {
    participate: '參與入金',
    repurchase: '復購',
    record: '入金記錄',
    selectAmount: '選擇數量',
    depositNow: '立即入金',
    payNow: '立即支付',
    balance: '餘額：',
    insufficientBalance: '餘額不足',
    enterAmount: '請輸入復購金額',
    minAmount: '復購金額不能小於',
    paySuccess: '支付成功，等待區塊到賬',
    historyRecord: '歷史記錄',
    status: '狀態：',
    pending: '待支付',
    completed: '已完成',
    failed: '失敗',
    currentIncome: '當前收益',
    accumulatedIncome: '累計收益',
    toBeReleased: '待釋放',
    released: '已釋放'
  },

  // 通用
  common: {
    confirm: '確認',
    cancel: '取消',
    submit: '提交',
    success: '成功',
    failed: '失敗',
    loading: '加載中...',
    noData: '暫無數據',
    copySuccess: '複製成功',
    copyFailed: '複製失敗',
    connectWallet: '鏈接錢包',
    disconnect: '斷開連接',
    invitationCode: '邀請碼',
    enterInvitationCode: '請輸入邀請碼'
  },

  // 提现
  withdrawal: {
    title: '提現',
    withdrawNow: '立即提現',
    withdrawAmount: '提現數量',
    fee: '手續費：',
    record: '提現記錄',
    balance: '餘額：',
    max: 'MAX',
    withdrawSuccess: '提現成功',
    notEnabled: '當前幣種提現未開啟',
    minAmount: '提現金額不能小於',
    maxAmount: '提現金額不能大於',
    exceedBalance: '提現金額不能大於餘額',
    noMore: '沒有更多了'
  },

  // HTTP错误
  http: {
    request: '請求錯誤',
    repetition: '重複請求',
    timeout: '請求超時',
    err: '鏈接服務器失敗!'
  }
}
